import React from "react";
import "./component.css";
import leftArrow from "../../../../assests/leftArrow.svg";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import { Link, useNavigate, useHistory } from "react-router-dom";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";

import uploadsvg from "../../../../assests/uploadsvg.svg";
import Papa from "papaparse";
import CreateCorporateComponent from "./CreateCorporate/component";
import AddCorporateUserComponent from "./AddUser/component";
import RechargeRuleComponent from "./RechargeRule/component";
import UsageLimitComponent from "./UsageLimit/component";

const BPCreateComponent = (props) => {
  const steps = [
    "Create Corporate",
    "Add User",
    "Recharge Rule",
    "Usage Limit",
  ];

  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/");
  };

  const handleCSVFileUpload = (file) => {
    if (file) {
      Papa.parse(file, {
        complete: (result) => {
          const csvData = result.data;

          if (csvData.length > 1) {
            const uidTokenPairs = csvData.slice(1).map((row) => ({
              uid: row[0],
              token: row[1],
            }));

            props.setInputs(uidTokenPairs);
          }
        },
        header: false,
      });
    }
  };

  const renderLeftSideButton = () => {
    if (props.activeStep === 1) {
      return (
        <>
          <input
            type="file"
            accept=".csv"
            onChange={(e) => handleCSVFileUpload(e.target.files[0])}
            style={{ display: "none" }}
            id="fileInput"
          />

          <label htmlFor="fileInput">
            <Button
              variant="contained"
              component="span"
              className="left-side-button"
            >
              <img style={{ marginRight: "8px" }} src={uploadsvg} alt="xyz" />
              Bulk Upload
            </Button>
          </label>
        </>
      );
    } else if (props.activeStep === 2) {
      return (
        <>
      {/* <Button variant="contained" onClick={props.handleSelectAll}>
          Select All
        </Button> */}
        </>
        
      );
    } else {
      return null;
    }
  };

  return (
    <div className="main-div">
      <Sidebar />

      <div>
        <div style={{ marginLeft: "42px", marginTop: "20px" }}>
          <h2>
            <img
              onClick={handleClick}
              style={{ width: "22px", cursor: "pointer" }}
              src={leftArrow}
              alt=""
            />{" "}
            Create a Corporate
          </h2>
        </div>
        <div style={{ marginLeft: "20px", width: "100%" }}>
          <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
            <div style={{ width: "100%", margin: "30px" }}>
              <Box sx={{ width: "50vw" }}>
                <Stepper activeStep={props.activeStep}>
                  {steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};

                    return (
                      <Step key={label} {...stepProps}>
                        <StepLabel {...labelProps}>{label} </StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              </Box>
            </div>

            <div className="left-side-button-container">
              {renderLeftSideButton()}
            </div>
          </div>

          <div>
            <React.Fragment>
              {props.activeStep === 1 ? (
                <>
                  <AddCorporateUserComponent
                   createUser={props.createUser}
                   setCreateUser={props.setCreateUser}
                   handleChangeUser={props.handleChangeUser}
                  />
                </>
              ) : props.activeStep === 2 ? (
                <>
                  <RechargeRuleComponent
                   activeBtn={props.activeBtn}
                   handleAddRechargeBtnClick={props.handleAddRechargeBtnClick}
                   handleAddRechargeBtnClick1={props.handleAddRechargeBtnClick1}
                   activeBtn1={props.activeBtn1}
                   handleChangeRecharge={props.handleChangeRecharge}
                   rechargeData={props.rechargeData}
                   setActiveBtn={props.setActiveBtn}
                   handleResetBalanceChange={props.handleResetBalanceChange}
                  />
                </>
              ) : props.activeStep === 3 ? (
                <>
                  <UsageLimitComponent
                   handleChangeUserLimit={props.handleChangeUserLimit}
                   userLimit={props.userLimit}
                   setUserLimit={props.setUserLimit}
                   useageLimit={props.useageLimit}
                   handleUserLimit={props.handleUserLimit}
                   
                   handleSelectChange={props.handleSelectChange}
                  />
                </>
              ) : (
                <>
                  <CreateCorporateComponent
                    createCorporateData={props.createCorporateData}
                    handleCreateCorporate={props.handleCreateCorporate}
                    handleChangeCorporate={props.handleChangeCorporate}
                   
                    setCreateCorporateData={props.setCreateCorporateData}
                  />
                </>
              )}
            </React.Fragment>
          </div>

          <Box className="backbtnaddpage">
            <Button
              className="backbtnaddpage1"
              // disabled={props.activeStep === 0}
              onClick={props.handleClose}
            >
              Back
            </Button>

            {props.activeStep === steps.length - 1 ? (
              <Button className="saveandcontinue" onClick={props.handleNext}>
                Save
              </Button>
            ) : (
              <Button className="saveandcontinue" onClick={props.handleNext}>
                Save and Continue
              </Button>
            )}
          </Box>
        </div>
      </div>
    </div>
  );
};

export default BPCreateComponent;
